import { Center, Loader } from '@mantine/core';

/** Fills the routed area while a lazy page chunk loads. */
export default function RouteFallback() {
	return (
		<Center h="100%" mih={200} w="100%">
			<Loader size="md" />
		</Center>
	);
}
